import { APP_VERSION } from 'config/constants/api.constants';
import { CSSProperties } from 'styled-components';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_STEP_RANGE_VALUE = 10;
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_MY_PURCHASE_PAGE_SIZE = 5;

const gridOptionalStyles: CSSProperties = {
  width: '-webkit-fill-available',
};

const filterOptionalStyle: CSSProperties = {
  width: '400px',
};

const onFilterOption = (input: string, option?: { label: string; value: string }) =>
  (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

const replaceTranslateKey = (translation: string, key: string, value: string): string => {
  return translation.replace(`#${key}`, value);
};

const getFullYearAndVersion = (): string => `©${new Date().getFullYear()}, v${APP_VERSION}`;

const GlobalUtils = {
  onFilterOption,
  replaceTranslateKey,
  gridOptionalStyles,
  filterOptionalStyle,
  getFullYearAndVersion,
};

export default GlobalUtils;
